import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { AdjustBanner, useShouldLoadAdjust } from "./AdjustBanner";
import { CustomBanner, useShouldLoadCustomBanner } from "./CustomBanner";
export const AppBanner = () => {
    const { isWebView } = useEnvironment();
    const shouldLoadAdjust = useShouldLoadAdjust();
    const shouldLoadCustomBanner = useShouldLoadCustomBanner();
    if (isWebView)
        return null;
    return (_jsxs(_Fragment, { children: [shouldLoadAdjust && _jsx(AdjustBanner, {}), shouldLoadCustomBanner && _jsx(CustomBanner, {})] }));
};
